import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { merge } from 'lodash-es';
import { ApiResponse } from "../../../classes/api-response";
import { SnackService } from "../../../services/snack.service";
import { Sim } from "../../../model/sim";
import { Box } from "../../../model/box";
import { SimsService } from "../../../services/sims.service";
import { BoxesService } from "../../../services/boxes-service";
import { Constants } from "../../../utils/constants";
import { CreateBoxDialogComponent } from "../../boxes/create-box-dialog/create-box-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { CreateSimDTO } from 'src/app/model/dto/sim/create-sim.dto';
import { UpdateSimDTO } from 'src/app/model/dto/sim/update-sim.dto';

@Component({
  selector: 'aw-sim-form',
  templateUrl: './sim-form.component.html',
  styleUrls: ['./sim-form.component.scss']
})
export class SimFormComponent implements OnInit {

  simForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  @Output() simEmitter: EventEmitter<Sim> = new EventEmitter<Sim>();
  @Input() creatingFromBox = false;

  loadingBoxes = false;
  saving = false;
  generalError?: ApiResponse;

  simStatus = Constants.simStatuses;
  entities = Constants.entities;
  dateNow?: string;

  boxes: Box[] = [];


  constructor(
    private simService: SimsService,
    private boxService: BoxesService,
    private snackService: SnackService,
    private dialog: MatDialog,
  ) {



    this.simForm = new UntypedFormGroup(
      {

        expirationDate: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        identifier: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        dataUsage: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        maxDataUsable: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        simOperator: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        monthlyFee: new UntypedFormControl(
          '',
          [
            Validators.required
          ]
        ),
        box: new UntypedFormControl(
          null,
          [
          ]
        ),
        status: new UntypedFormControl(
          this.simStatus.unassigned,
          [
          ]
        ),
      }
    );
  }

  _sim = new Sim();
  selectedBox?: Box;
  isEditing = false;

  @Input() set sim(value: Sim) {
    this._sim = merge(new Sim(), value);
    // this.selectedBox = value.box;
    this.isEditing = !!this._sim.id;
    this.simForm.patchValue(this._sim);
  }

  ngOnInit(): void {
    this.loadingBoxes = true;
    this.dateNow = new Date(Date.now()).toISOString();

    if (!this.isEditing) {
      this.boxService.getAllBoxes().subscribe(boxes => {
        boxes.forEach(box => {
          if (!box.sim)
            this.boxes.push(box);
        });
        this.loadingBoxes = false;
      });
    }

  }

  saveSim(): void {

    this.saving = true;

    const newSim = merge(new Sim(), this._sim, this.simForm.value);

    this.generalError = undefined;

    if (this._sim.id) {
      const updateSimDTO = new UpdateSimDTO(newSim);
      this.simService.updateSim(this._sim.id, updateSimDTO)
        .subscribe(
          () => {
            this.saving = false;
            this.sim = newSim;
            this.snackService.success('Sim updated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    } else {
      const createSimDTO = new CreateSimDTO(newSim);
      this.simService.createSim(createSimDTO)
        .subscribe(
          createdSim => {
            this.saving = false;
            this.sim = createdSim;
            this.simEmitter.emit(createdSim);
            this.snackService.success('Sim created!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }

  }

  openBoxForm(): void {
    this.dialog.open(CreateBoxDialogComponent, { data: { creatingFromSim: true } })
      .afterClosed()
      .subscribe(
        box => {
          this.selectedBox = box;
          if (this.selectedBox) {
            this.boxes.push(this.selectedBox);
          }
        });
  }

}
